// "Pricing" card of a ShareJet booking: price per seat and total.
import { Card, Descriptions, Typography } from 'antd';

import type { AdminBookingDetail } from '../../api/types';
import { gbp } from '../../data/format';

const { Text } = Typography;

export function PricingCard({ b }: { b: AdminBookingDetail }) {
  return (
    <Card title="Pricing">
      <Descriptions column={{ xs: 1, sm: 2 }} bordered size="small">
        <Descriptions.Item label="Price per seat">
          {gbp(b.seatPriceGbp)}
        </Descriptions.Item>
        <Descriptions.Item label="Total">
          <Text strong>{gbp(b.totalGbp)}</Text>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
